const locale = {
  'c.ApplyAccount.title': 'Apply for Account Opening',

  'c.ApplyAccount.label.countryCode': 'Country',
  'c.ApplyAccount.label.companyName': 'Your Company Name',
  'c.ApplyAccount.label.userName': 'Your Name',
  'c.ApplyAccount.label.contactInformation': 'Your mobile phone number or email address',
  'c.ApplyAccount.label.remark': 'What problems do you want to solve through casschoice?',

  'c.ApplyAccount.placeholder.pleaseSelect': 'Please select',
  'c.ApplyAccount.placeholder.pleaseEnter': 'Please enter',
  'c.ApplyAccount.placeholder.contactInformation': 'Please enter your WhatsApp or email address',

  'c.ApplyAccount.button.submit': 'Sign up',
  'c.ApplyAccount.text.disclaimerText':
    'I have read and agreed to the {serviceAgreement} and {privacyPolicy}',
  'c.ApplyAccount.text.agreeTextMessage': 'I agree to receive text message',
  'c.ApplyAccount.text.notice':
    'We will process your application within 3 business days of receipt and contact you via email or WhatsApp. Please check your messages.',

  'c.ApplyAccount.disclaimerText.error': 'Please read and agree to the agreement first.',
  'c.ApplyAccount.agreeTextMessage.error': 'Please agree to receive text message first.',

  'c.ApplyAccount.request.loading': 'Submitting...',
  'c.ApplyAccount.request.success':
    'Submit successfully and we will complete your registration application within 3 working days',
  'c.ApplyAccount.request.error': 'Submission failed! Please try again later.',
};
export default locale;
